import React from 'react';
import { useObservable } from 'react-use-observable';

import { Card, Tag } from 'antd';

import CopyText from 'v2/components/Shared/CopyText';
import { EPaymentMethod, type IRefundRequest, type ShoppingDelivery } from 'v2/interfaces/shopping';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

interface BuyerDetailsProps {
  delivery: ShoppingDelivery;
}

export function BuyerDetails({ delivery }: BuyerDetailsProps) {
  const [refundRequest] = useObservable<IRefundRequest>(
    () => refundRequestFactory.buyerFindRefundByInvoiceId(delivery.invoice_id),
    []
  );

  function getPaymentMethodName(invoice: ShoppingDelivery) {
    if (invoice.payment_method.id === EPaymentMethod.PIX_AUTOMATICO) return invoice.payment_method.method;
    return invoice.payment_method.name;
  }

  return (
    <Card size='small' title='Informações da compra'>
      <div className='flex flex-col gap-1'>
        {delivery.customer.name && (
          <div className='text-sm'>
            <span className='font-semibold'>Nome:</span> {delivery.customer.name}
          </div>
        )}
        {delivery.customer.email && (
          <div className='text-sm'>
            <span className='font-semibold'>E-mail:</span> <CopyText value={delivery.customer.email} />
          </div>
        )}
        {delivery.customer.celphone && (
          <div className='text-sm'>
            <span className='font-semibold'>Fone:</span> <CopyText value={delivery.customer.celphone} />
          </div>
        )}
        {delivery.payment_method.name && (
          <div className='text-sm'>
            <span className='font-semibold'>Forma de pagamento:</span> {getPaymentMethodName(delivery)}
          </div>
        )}
        {delivery.installments ? (
          <div className='text-sm'>
            <span className='font-semibold'>Parcelamento:</span> {delivery.installments}x
          </div>
        ) : null}
        {delivery.card_number && (
          <div className='text-sm'>
            <span className='font-semibold'>Cartão:</span> <CopyText value={delivery.card_number} />
          </div>
        )}
        {!refundRequest?.exist &&
          refundRequest?.refund_due_date &&
          delivery.payment_method.id !== EPaymentMethod.BOLETO_PARCELADO && (
            <div className='text-sm'>
              <span className='font-semibold'>Prazo para reembolso:</span> {refundRequest?.refund_due_date}{' '}
              {refundRequest?.expired && <Tag color='red'>Expirado</Tag>}
            </div>
          )}
      </div>
    </Card>
  );
}
